var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 18h12c.6 0 1-.5 1-1s-.4-1-1-1H8c-.5 0-1 .5-1 1s.5 1 1 1zm-4-5h16c.6 0 1-.5 1-1s-.5-1-1-1H4c-.6 0-1 .5-1 1s.5 1 1 1zm1.9-6c0 .6.5 1 1 1H20c.6 0 1-.5 1-1s-.4-1-1-1H6.9a1 1 0 0 0-1 1z"
  })));
};

export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QjRiV3h1Y3owaWFIUjBjRG92TDNkM2R5NTNNeTV2Y21jdk1qQXdNQzl6ZG1jaUlIWnBaWGRDYjNnOUlqQWdNQ0F5TkNBeU5DSStDaUFnUEhCaGRHZ2dabWxzYkQwaVkzVnljbVZ1ZEVOdmJHOXlJZ29nSUNBZ1pEMGlUVGdnTVRob01USmpMallnTUNBeExTNDFJREV0TVhNdExqUXRNUzB4TFRGSU9HTXRMalVnTUMweElDNDFMVEVnTVhNdU5TQXhJREVnTVhwdExUUXROV2d4Tm1NdU5pQXdJREV0TGpVZ01TMHhjeTB1TlMweExURXRNVWcwWXkwdU5pQXdMVEVnTGpVdE1TQXhjeTQxSURFZ01TQXhlbTB4TGprdE5tTXdJQzQyTGpVZ01TQXhJREZJTWpCakxqWWdNQ0F4TFM0MUlERXRNWE10TGpRdE1TMHhMVEZJTmk0NVlURWdNU0F3SURBd0xURWdNWG9pSUM4K0Nqd3ZjM1puUGc9PSI=";